import { Modal } from 'antd';

import { CANCEL, SAVE } from '@app/constants';
import type { MarkAsReadModalProps } from '@app/pages/SalesFunnels/LogsRegistry/types';

import type { FC } from 'react';

export const MarkAsReadModal: FC<MarkAsReadModalProps> = ({
  open,
  handleMarkAsReadModalCancel,
  handleMarkAsRead,
  markType,
  isLoading,
}) => {
  const getModalDescription = () => {
    switch (markType) {
      case 1:
        return 'Прочитать все имеющие логи?';
      case 2:
        return 'Прочитать выбранные логи?';
      case 3:
        return 'Прочитать все логи, входящие в фильтр?';
      default:
        return;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleMarkAsReadModalCancel}
      onOk={handleMarkAsRead}
      okText={SAVE}
      cancelText={CANCEL}
      title="Пометить логи как прочитанные"
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      {getModalDescription()}
    </Modal>
  );
};
